import { UntitledIcon } from '@faceup/icons'
import { ulHome01 } from '@faceup/icons/ulHome01'
import { ulRefreshCw01 } from '@faceup/icons/ulRefreshCw01'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { useRouteError } from '@faceup/router'
import { useComponentDidMount } from '@faceup/ui'
import { Button, Result } from '@faceup/ui-base'
import { NoShortIdError } from '../errors/NoShortIdError'

const messages = defineMessages('followUp.components.routerError', [
  { id: 'description', defaultMessage: '' },
  { id: 'buttonBackHome', defaultMessage: '' },
  { id: 'buttonReload', defaultMessage: '' },
] as const)

export const RouterError = () => {
  const error = useRouteError()

  useComponentDidMount(() => {
    if (error instanceof NoShortIdError) {
      window.location.href = '/'
    }
  })

  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <Result
        status='500'
        title='500'
        subTitle={<FormattedMessage message={messages.description} />}
        extra={
          <div className='inline-flex flex-col gap-2'>
            <Button
              type='default'
              onClick={() => window.location.reload()}
              icon={<UntitledIcon icon={ulRefreshCw01} />}
            >
              <FormattedMessage message={messages.buttonReload} />
            </Button>

            <Button
              type='primary'
              onClick={() => (window.location.href = '/')}
              icon={<UntitledIcon icon={ulHome01} />}
            >
              <FormattedMessage message={messages.buttonBackHome} />
            </Button>
          </div>
        }
      />
    </div>
  )
}
